import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transition as ReactTransition } from 'react-transition-group';
import HistoryEventTypes from '../constants/history-event-types';
import TransitionConfigTypes from '../constants/transition-config-types';

class PageTransition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exiting: false
    };
  }

  listenerHandler = (event) => {
    this.setState({ exiting: true });
  }

  componentDidMount() {
    window.addEventListener(HistoryEventTypes.EXITING, this.listenerHandler);
  }

  componentWillUnmount() {
    window.removeEventListener(HistoryEventTypes.EXITING, this.listenerHandler);
  }

  componentWillReceiveProps(newProps) {
    if (this.state.exiting) {
      this.setState({ exiting: false });
    }
  }

  render() {
    return (
      <ReactTransition appear timeout={TransitionConfigTypes.TRANSITION_TIMEOUT} in={!this.state.exiting}>
        {status => (
          <div className={this.props.cn(String(), [status])}>
            {this.props.children}
          </div>
        )}
      </ReactTransition>
    );
  }
}

PageTransition.propTypes = {
  cn: PropTypes.func.isRequired
};

export default PageTransition;



// WEBPACK FOOTER //
// ./src/components/page-transition.js